import PropTypes from "prop-types";
import React from "react";
import { Container } from "semantic-ui-react";
import UpscaleCardGroup from "shared/components/affiliates/upscale/upscaleCardGroup";
import AdditionalProjectHtml from "buyer_portal/components/additionalProjectHtml";
import PageTotal from "./PageTotal";
import RoomBookNavigation from "./RoomBookNavigation";
import BottomNavigation from "./BottomNavigation";

export default class CatalogPage extends React.Component {
  static propTypes = {
    children: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
      .isRequired
  };

  render() {
    const { children } = this.props;

    return (
      <div>
        <Container>
          <RoomBookNavigation />
          {children}
          <PageTotal />
          <AdditionalProjectHtml />
          <UpscaleCardGroup />
        </Container>
        <BottomNavigation />
      </div>
    );
  }
}
